module.exports = __webpack_public_path__ + "img/refresh.bdff54e6.svg";